import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogRef, DynamicDialogConfig } from "primeng/dynamicdialog";
import { DataService_LocationMaintenance } from "../shared/data.service";
import { wsFacilityLocationEditParm } from "../shared/wsFacilityLocationEditParm";
import { wsFacilityLocationListInfo } from "../shared/wsFacilityLocationListInfo";
import { wsSchoolFacilityListInfo } from "../shared/wsSchoolFacilityListInfo";

@Component({
	selector: "app-ms-location-edit",
	templateUrl: "./ms-location-edit.component.html",
	styleUrls: ["./ms-location-edit.component.css"],
})
export class MsLocationEditComponent implements OnInit {
	constructor(
		private dataService: DataService_LocationMaintenance,
		public ref: DynamicDialogRef,
		private confirmationService: ConfirmationService,
		public dialogConfig: DynamicDialogConfig
	) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	Globals
	//
	//-----------------------------------------------------------------------------------------------------
	public isBusy: boolean = false;

	public UserPersonID: number;
	public SchoolID: number;
	public SelectedFacilityLocation: wsFacilityLocationListInfo;

	public lstSchoolFacility: wsSchoolFacilityListInfo[] = [];
	public SelectedSchoolFacility: wsSchoolFacilityListInfo;

	public isAllowFacilityChange: boolean = false;
	public FacilityLocationCD: string = "";
	public FacilityLocationName: string = "";

	public ErrorMessage: string = "";

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnInit
	//
	//-----------------------------------------------------------------------------------------------------
	ngOnInit() {
		this.isBusy = true;

		this.UserPersonID = this.dialogConfig.data.UserPersonID;
		this.SchoolID = this.dialogConfig.data.SchoolID;
		this.SelectedFacilityLocation = this.dialogConfig.data.SelectedFacilityLocation;

		this.isBusy = true;
		this.dataService.SchoolFacilitySelectList(this.SchoolID).subscribe((data) => this.SchoolFacilitySelectList_Complete(data));
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnDestroy
	//
	//-----------------------------------------------------------------------------------------------------
	ngOnDestroy() {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	SchoolFacilitySelectList_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	SchoolFacilitySelectList_Complete(data: any) {
		this.lstSchoolFacility = data;

		this.FacilityLocationCD = this.SelectedFacilityLocation.FacilityLocationCD;
		this.FacilityLocationName = this.SelectedFacilityLocation.FacilityLocationName;
		this.isAllowFacilityChange = this.lstSchoolFacility[0].isAllowFacilityChange;
		//
		//	Default select
		//
		this.SelectedSchoolFacility = this.lstSchoolFacility[0];

		this.lstSchoolFacility.forEach((item) => {
			if (item.FacilityID == this.SelectedFacilityLocation.FacilityID) {
				this.SelectedSchoolFacility = item;
			}
		});

		this.isBusy = false;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onSchoolFacilityChange
	//
	//-----------------------------------------------------------------------------------------------------
	onSchoolFacilityChange(value) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onEdit
	//
	//-----------------------------------------------------------------------------------------------------
	onEdit() {
		this.ErrorMessage = "";

		let parms: wsFacilityLocationEditParm = {
			FacilityLocationID: this.SelectedFacilityLocation.FacilityLocationID,
			FacilityLocationCD: this.FacilityLocationCD,
			FacilityLocationName: this.FacilityLocationName,
			FacilityID: this.SelectedSchoolFacility.FacilityID,
		};

		this.isBusy = true;
		this.dataService.FacilityLocationEdit(parms).subscribe((data) => this.FacilityLocationEditUpdate_Complete(data));
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	FacilityLocationEditUpdate_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	FacilityLocationEditUpdate_Complete(data: any) {
		this.isBusy = false;
		this.ErrorMessage = data[0];

		//
		// 0 = CANCEL; 1 = SAVE
		//
		if (this.ErrorMessage.length == 0) {
			this.ref.close(1);
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onClose
	//
	//-----------------------------------------------------------------------------------------------------
	onClose() {
		//
		// 0 = CANCEL; 1 = SAVE
		//
		this.ref.close(0);
	}
}
